import EventBus from '@/event-bus'
import api      from '@/api'
import axios    from 'axios';
import momentz          from 'moment-timezone';
import moment           from 'moment';
import FaceService      from '@/services/face.service.js';

let ext         = api && api.ext ? api.ext  : ``;
let proto       = api && api.protocol ? api.protocol : 'http:';
let debug       = false;
let url         =  location.hostname;
let URL_        = proto + '//' + url + ':' + '9090' ;

momentz.locale('en');
let time_zone = momentz.tz.guess(); //`America/Bogota`;

if (localStorage.getItem('time_zone')) {
  time_zone = JSON.parse(localStorage.getItem('time_zone'));
}

if (url == `.`) {
  url  = `localhost`;
}
if (api) {  
  URL_ = api.url;
}

const API_URL           = URL_;

let user            = null;
axios.defaults.withCredentials  =   false;

try{
  if (localStorage.getItem('user')) {
    user = JSON.parse(localStorage.getItem('user'));
    if (user && user.jwt) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${user.jwt}`;
    }
  }
}catch(e){
  console.warn("Error convert json usr req", e);
}

class helpers {  
  searcher(list, search, key){
    /*
      list = array to search
      search = keyword to find 
      key  =  if content object the key in string ''
    */
    if (list && list.length) {
      let obj = null,
          idx = null;
          if (debug) {
            console.log("searcher: ", search, key)
          }
      const finded = list.some( function(arr_find, idx_find){
        if ( arr_find == search || (key && arr_find[key] == search) ) {
          // console.log("fINDED ************ ", arr_find, idx_find);
          obj = arr_find;
          idx = idx_find;
          return true;
        }
      })
      if (finded) {
        return { obj, idx }
      }
    }
    return null;
  } // find item

  searcherAll(list, search, key){
    /*
      list = array to search
      search = keyword to find 
      key  =  if content object the key in string ''
    */
    if (list && list.length) {
      let obj = [],
          idx = null;
      const finded = list.forEach( function(arr_find, idx_find){
        if ( arr_find == search || (key && arr_find[key] == search) ) {
          // console.log("fINDED ************ ", arr_find, idx_find);
          obj.push(arr_find);
          // idx = idx_find;
          
        }
      })
      if (obj && obj.length > 0) {
        return { obj }
      }
    }
    return null;
  } //
  // type = get | get_post | create | update | del  
  request(endpoint, type, info ){
  // console.log("test req helpers ",endpoint, type, info  )
    new Promise((resolve, reject) =>{

      if (Request && Request[type]) {

        Request[type](endpoint, info).then(response =>{
          // console.log("TEST req request", response);

          resolve(response);
        }).catch(err=>{
          reject(err);
        });
      }else{
        reject(null)
        console.log("No found req : ", type)
      }
    })
  }

  set_debug(val){
    debug = val;
  }

  get_local(key){
    let info_local = null;
    if (localStorage.getItem(key)) {
      try{ 
        info_local = JSON.parse(localStorage.getItem(key));
      }catch(er){
        console.log("Error convert parse local helper : ", er);
      }
    }
    return info_local;
  }

  set_local(key, item){
    try {

        if (localStorage.getItem(key)) {
          if (debug) {
            console.log("Exist this " + key + " in local");
          }
        }
        let info_to_local = item;
        if (Array.isArray(item)) {
          info_to_local = [...item];
        }else if (typeof item == 'object') {
          info_to_local = {...item};
        }
      localStorage.setItem(key, JSON.stringify(info_to_local));    
      return true
    }catch(er){
      console.warn("Error Set local ", key, er);
    }

  } // set local

  get_local_session(key){
    let info_local = null;
    if (sessionStorage.getItem(key)) {
      try{
        info_local = JSON.parse(sessionStorage.getItem(key));
      }catch(er){
        console.log("Error convert parse session helper : ", er);
      }
    }
    return info_local;
  }

  set_local_session(key, item){
    let info_set = item;
      if (sessionStorage.getItem(key)) {
        if (debug) {
          console.log("Exist this " + key + " in local");
        }
      }
    sessionStorage.setItem(key, JSON.stringify(item));    
    return true

  } // set local
  
  to_object(item){
    try{
      if (typeof item == "string") {
        return  JSON.parse(item);
      }
      return null;
    }catch(er){
      console.warn("Error convert to Object : ", er);
      return null;
    }
  } // convert to object

  to_string(item){
     try{
        return  JSON.stringify(item);
    }catch(er){
      console.warn("Error convert to String : ", er);
      return null;
    }
  } // convert to string - ify

  async file_to_b64(file){
    // console.log("FILE ", file)
    return new Promise((resolve, reject) => {
       const reader = new FileReader();
        reader.readAsDataURL(file && file.length > 0 ? file[0] : file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    
  } // file to b64

  current_auth_user(currentUser,item){
    // console.log("check permission ", currentUser, item)
    if (currentUser && currentUser.user && item && (item.roles && item.roles.length > 0 && item.roles.includes(currentUser.user.roleId))){
      return true;
    }
    return false
  } // currrent_auth_user

  keyboard_is_active(keys, id_notification, type, obj, value, func){
    let key_board = false;
    if (localStorage.getItem('virtual_Key_board')) {
      key_board = JSON.parse(localStorage.getItem('virtual_Key_board'));
    }       
    // console.log(key_board , "KEYbOARD ACTIVE ")
    if (key_board) {              
      /*if (this[keys]) {
          this[keys] = '';
      }*/
      // keys         
      EventBus.$emit('active_keyboard_key',{
        ID   : id_notification,
        key  : keys,
        type,
        obj,
        func,
        value
      });
    }       
  } // keyboard_is_active

// clear obj or convert array to object
  set_property_obj(items){
    if (items && items.length > 0) {
      
      let field_new   = {};
      items.forEach((field) =>{
        // if (field.enable) {
          field_new[field.key] = '';
        // }
      })
     return field_new;
    }
    return null;
  }


  // format the object for request
  format_req(item, list){
    let formated = null;
    if (list && list.length > 0) {
      formated = {};
      list.forEach((item_format)=>{
        if (item_format) {
          formated[item_format] = item[item_format];
        }
      });
    }
    return formated;
  }
  renderImageEntity(item){
    if(item?.face_trained?.length){
      // console.log("jjhhb ", item, item.face_trained[0]?.face_cropping?.url)
      item.name_entity=item.face_trained[0].name;
      item.urlImg=this.check_img(item.face_trained[0]?.face_cropping?.url, API_URL)
      return item.urlImg
    }else if(item?.face_trained && item?.face_trained?.face_cropping){
      // console.log("- ",this.check_img(item.face_trained.face_cropping?.length? item.face_trained.face_cropping?.[0]?.url : item.face_trained.face_cropping?.url,API_URL))
      item.name_entity=item.face_trained.name;
      item.urlImg=this.check_img(item.face_trained.face_cropping?.length? item.face_trained.face_cropping?.[0]?.url : item.face_trained.face_cropping?.url, API_URL)
      return item.urlImg
    }
    return this.check_img(null,API_URL);
  }
  check_img(item, url){
    let image =  ext + '/img/no_img_found.png';    
    if (item) {      
      if (item.includes('http')){
        image =  item;         
        if (item.includes("NaN") && item.split(".").length == 1) {
          image =  ext + '/img/no_img_found.png';
        }else
        if (item.includes(undefined) &&  item.split(".").length == 1) {
          image =  ext + '/img/no_img_found.png';          
        }   
        
      }else
      if (item.includes("data:image")){
        image = item;
      }else 
      if (item.includes("no_MatchFace")) {
         image = item;
      }
      else{

        if (!item.includes('no_img_found')) {
          image = url + '/' + item
        }
        if (item.includes('/tags')) {
          image = item;
        }
      }
      /*if (item.includes('no_img_found') && item.includes('http')) {
        console.log("3 : ",item)
        
        image = '/img/no_img_found.png';

      }*/
       
    }
   
    return image;
  }

/*
  b  = bytes
  mb = megabytes
  gb = gigabyes
*/
  convert_capacity(act, item, opt = 'string', rev = false){
    let bytes   = 0;
    let result  = null;
    let revert  = rev;
    if (['mb_to_b', 'b_to_mb', 'mb'].includes(act)) {
      bytes = 1048576; // 1000000
    }
    if (['gb_to_b', 'b_to_gb', 'gb'].includes(act)) {
      bytes = 1073741824;
    }
    
    if (bytes > 0) {

      if (revert) {
        result = item / bytes; // revert capacity 
      }else{
        result = item * bytes; // convert to capacity
      }
      result = result % 1 == 0 ? parseInt(result) :  result.toFixed(2);
      if (opt == 'string') {
        result = String(result);
      }
    }else{
      console.log("Required a capacity to convert");
    }
    return result;

  } // convert_capacity

  log(item, name, msg, opt = 'log'){
    if (debug) {      
      console.log("-------------------------------------------------");
      console[opt](
        "LOG   : ", item ,
        `
        ******
        MSG   : ${msg} 
        ****** 
        COMP  : ${name}`);
    }
  }

  filter_search(search, list, opt){
      let list_filter = [];
      if (opt) {
        const tempSearch = search?.toLowerCase();
        list_filter = list.filter( item => {
          return item && item[opt.key_search]?.toLowerCase().indexOf(tempSearch) > -1;
        });
        if (list_filter.length === 0 && opt.key_search_1) {          
          list_filter = list.filter( item1 => {
          return item1 && item1[opt.key_search_1] && item1[opt.key_search_1]?.toLowerCase().indexOf(tempSearch) > -1;
          });
          
        }
      }
      return list_filter
  }

  reloadPage(){
    if(location && location.hostname == `.` || location.hostname == `chromewebdata` || location.localhost == `.`){ // localhost                
      mainWindow.reload();              
    }else {
      location.reload(); 
    }
  }
  percentMonitorMemory() {
    if (performance && performance.memory) {
      const memory = performance.memory;
      const used = memory.usedJSHeapSize;
      const total = memory.totalJSHeapSize;
      const percent = (used / total) * 100;
      return Math.round(percent);
    }
    return null;
  }

  detectBrowser() {
    const ua = navigator.userAgent.toLowerCase();

    if (/crios|chrome|chromium/.test(ua)) {
      return 'Chrome o Chromium';
    } else if (/fxios|firefox/.test(ua)) {
      return 'Firefox';
    } else if (/safari/.test(ua) && !/chrome|chromium|crios/.test(ua)) {
      return 'Safari';
    } else if (/edgios|edg/.test(ua)) {
      return 'Edge';
    } else if (/opr\//.test(ua)) {
      return 'Opera';
    } else {
      return 'Other';
    }
  }

  isChromeOrChromium(){
    const ua = navigator.userAgent.toLowerCase();
    return /chrome|chromium|crios/.test(ua); // "crios" = Chrome en iOS
  }

  async downloadImage(source, nombreArchivo = 'imagen.png') {
    let url;
    if (typeof source === 'string') {
      try {
        // Ver si es base64
        if (source.startsWith('data:image/')) {
          url = source;
        } else {
          // Descargar imagen como Blob
          const response = await fetch(source, { mode: 'cors' });
          const blob = await response.blob();
          url = URL.createObjectURL(blob);
        }
      } catch (error) {
        console.error('Error al descargar la imagen:', error);
        return;
      }
    } else if (source instanceof HTMLCanvasElement) {
      url = source.toDataURL('image/png');
    } else {
      console.error('Fuente no válida. Debe ser una URL, base64 o un canvas.');
      return;
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = nombreArchivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Liberar el objeto URL si fue creado con createObjectURL
    if (url.startsWith('blob:')) {
      URL.revokeObjectURL(url);
    }
    url = null;

    // URL normal
    // descargarImagen('https://ejemplo.com/imagen.jpg', 'foto.jpg');

    // Base64
    // descargarImagen('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAA...', 'base64.png');

    // Canvas
    // const canvas = document.getElementById('miCanvas');
    // descargarImagen(canvas, 'canvas.png');
  }


  renderOperation(operation, itemsCount1, itemsCount2){     
    let total = 0;    
    if(typeof itemsCount1 == 'number' && typeof itemsCount2 == 'number'){
      // const arrayCount = []//Object.values(itemsCount);      
      switch (operation) {
        case '+':
          return itemsCount1 + itemsCount2;
        case '-':
          return itemsCount1 - itemsCount2;
        case '*':
          return itemsCount1 * itemsCount2;
        case '/':
          if (itemsCount2 === 0) {
            return 'No es posible dividir por cero.';
          }
          return itemsCount1 / itemsCount2;
        default:
          return 'Operador no válido.';
      }
    }
    return total
  }

  clear_bus(eventbus, bus_channels, text = ''){
    if (bus_channels) {
      
      for(let bus_name in bus_channels){
        // console.log("close connection", bus_name);
        if (bus_name && bus_channels[bus_name]) {
          eventbus.$off(bus_name, bus_channels[bus_name]);
        }
      }
      if (debug) {
        console.log("clear Bus : ", text)
      }
    }
  } // clear bus

  getDateFormat(item, format="HH:mm"){ // 'YYYY-MM-DD' / HH:mm /  
    return moment(item).format(format)
  }

  isDiffDate(item){
    const beforeDate=moment(item)
    const currentDate=moment();
    console.log("CHECK DATE VALID ", item, beforeDate, currentDate.format("YYYY-MM-DD"))
    return currentDate.diff(beforeDate, 'days') >= 1;    
  }
  formatDate(item, parse_format = 'timestamp', formate = 'll, LTS'){
    let date_format = null;
    if (item) {

      if (parse_format == 'timestamp') {
        if (typeof item === 'string' && /^\d+$/.test(item.trim())) {
          const t = item.trim();
          let len = t.length;
          let n = parseInt(t, 10);
          if (len === 16) {
            n = Math.floor(n / 1000);
          }
          while (n > 1e14) {
            n = Math.floor(n / 1000);
          }
          if (n < 1e11) {
            n = Math.round(n * 1000);
          }
          const y = momentz(n).year();
          if (y >= 1980 && y <= 2110) {
            date_format = momentz(n).format(formate);
          }
        } else if (typeof item === 'number' && Number.isFinite(item)) {
          let n = item;
          const len = String(Math.trunc(Math.abs(n))).length;
          if (len === 16) {
            n = Math.floor(n / 1000);
          }
          while (n > 1e14) {
            n = Math.floor(n / 1000);
          }
          if (n < 1e11) {
            n = Math.round(n * 1000);
          }
          const y = momentz(n).year();
          if (y >= 1980 && y <= 2110) {
            date_format = momentz(n).format(formate);
          }
        } else {
          let len = 10;
          if (typeof item == "string") {
            len = item.length;
          } else {
            len = (''+ item).length;
          }
          if (len == 16) {
            item = Math.floor(item/1000.0);
          }
          date_format = momentz(parseInt(item, 10)).format(formate);
        }
      } // timestamp
      else if (parse_format == 'createdAt')
      {
        date_format = momentz(item).format(formate);
      }// createdAt
      
    } // item
    return date_format;
  }

  formatDatePicker(dates = [], guess = true){
    let tempGuess=momentz.tz.guess();
    let date1 = guess && tempGuess ?  
      momentz(momentz.now()).tz(tempGuess).format('YYYY-MM-DD') : 
      momentz(momentz.now()).format('YYYY-MM-DD'); // L / YYYY/MM/DD
    if (dates && dates.length > 0) {
      if (dates[0] == 'Invalid date') {
        dates[0] = date1; //momentz(date1).format('YYYY-MM-DD');
      }else{
        dates[0] = momentz(dates[0]).format('YYYY-MM-DD');
      }

      if (dates[1] == 'Invalid date') {
        dates[1] = dates[0]; //momentz(dates[0]).format('YYYY-MM-DD'); 
      }else{
        dates[1] = momentz(dates[1]).format('YYYY-MM-DD');
      }
    }else{    
      dates    = [];
      dates[0] = date1; //momentz(date1).format('YYYY-MM-DD');
      dates[1] = dates[0]
    }
    return dates;

  }

  is_valid_ip(str){
    let verdad = str.split('.');
      if(verdad.length != 4)
        return false;
      for(let i in verdad){
        if(!/^\d+$/g.test(verdad[i])
        ||+verdad[i]>255
        ||+verdad[i]<0
        ||/^[0][0-9]{1,2}/.test(verdad[i]))
          return false;
      }
      return true;
  } // is valid ip
  // Requests
  text_length(text){
    if (text.length > 23) {
      return true
    }
    return false
  } // text length

  redirectOpenWindow(link){    
    window.open(link,'_blank');
  }

  sleep(time){
    return  new Promise(resolve=>{
      const clear = setTimeout(()=> {
        resolve(true);
        clearTimeout(clear)
      },time)
    })
    
    
  }
  generateUUIDv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    })
  }

  validateFaceUpload(imgs){
    return FaceService.validateTrainingUpload(imgs);
  }
  formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  }

  loadVideoBlob(url) {
    if (!url) {
      return Promise.reject(new Error('Se requiere una URL para cargar el blob de video'));
    }
    return axios.get(url, { responseType: 'blob' }).catch(error => {
      console.warn(`Error al cargar el blob de video desde ${url}:`, error);
      throw error;
    });
  }

  // Enhanced video loading with range request support for large videos
  async loadVideoBlobWithProgress(url, onProgress = null) {
    if (!url) {
      return Promise.reject(new Error('Se requiere una URL para cargar el blob de video'));
    }

    try {
      // First, get video size
      const headResponse = await fetch(url, { method: 'HEAD' });
      const contentLength = headResponse.headers.get('content-length');
      const totalSize = contentLength ? parseInt(contentLength) : 0;
      
      if (totalSize === 0) {
        // Fallback to regular axios if size unknown
        return this.loadVideoBlob(url);
      }

      const videoSizeMB = totalSize / (1024 * 1024);
      
      // For videos larger than 50MB, use streaming with range requests
      if (videoSizeMB > 50) {
        return this.loadLargeVideoWithRanges(url, totalSize, onProgress);
      } else {
        // For smaller videos, use regular blob loading
        return this.loadVideoBlob(url);
      }
      
    } catch (error) {
      console.warn(`Error al cargar el video desde ${url}:`, error);
      // Fallback to regular loading
      return this.loadVideoBlob(url);
    }
  }

  async loadLargeVideoWithRanges(url, totalSize, onProgress = null) {
    const chunkSize = 1024 * 1024; // 1MB chunks
    const chunks = [];
    let loadedSize = 0;

    for (let start = 0; start < totalSize; start += chunkSize) {
      const end = Math.min(start + chunkSize - 1, totalSize - 1);
      
      try {
        const response = await fetch(url, {
          headers: {
            'Range': `bytes=${start}-${end}`
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const chunk = await response.arrayBuffer();
        chunks.push(new Uint8Array(chunk));
        loadedSize += chunk.byteLength;

        // Report progress
        if (onProgress) {
          const progress = Math.round((loadedSize / totalSize) * 100);
          onProgress(progress, loadedSize, totalSize);
        }

      } catch (error) {
        console.warn(`Error loading chunk ${start}-${end}:`, error);
        throw error;
      }
    }

    // Combine all chunks into a single blob
    const totalLength = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
    const combinedArray = new Uint8Array(totalLength);
    let offset = 0;
    
    for (const chunk of chunks) {
      combinedArray.set(chunk, offset);
      offset += chunk.length;
    }

    return {
      data: combinedArray,
      headers: { 'content-type': 'video/mp4' }
    };
  }

  base64ToBlob(base64, contentType) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  async base64ToBlobUrl(base64) {
    try {
      if (base64) {
        const byteCharacters = atob(base64.split(',')[1]);  
        const byteNumbers = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const blob = new Blob([byteNumbers], { type: 'image/jpeg' });
        return URL.createObjectURL(blob);
      }
    } catch (error) {
      console.error('Error al convertir base64 a Blob:', error);
      return null;
    }
  }

  get(endpoint, info){
    const URL = API_URL + endpoint; 
    return new Promise((resolve, reject)=>{

      axios.get(URL).then(res => {
        // console.log("req res get ", res)
        resolve(res);
      }).catch(er => {
        // console.log("req er get ", er)

        reject(er);
      })
    })

  }
  get_post(endpoint, info){
    const URL = API_URL + endpoint; 
    return new Promise((resolve, reject)=>{

      axios.post(URL, info).then(res => {
        resolve(res);
      }).catch(er => {
        reject(er);
      })
    })
  
  }

  create(endpoint, info){
    const URL = API_URL + endpoint; 
    return new Promise((resolve, reject)=>{

    axios.post(URL, info).then(res => {
      resolve(res);
    }).catch(er => {
      reject(er);
    })
    })

  }

  update(endpoint, info){
    const URL = API_URL + endpoint; 
    return new Promise((resolve, reject)=>{
    
    axios.get(URL).then(res => {
      resolve(res);
    }).catch(er => {
      reject(er);
    })
    })

  }
  del(endpoint, info){
    const URL = API_URL + endpoint; 
    return new Promise((resolve, reject)=>{
    
    axios.delete(URL).then(res => {
      resolve(res);
    }).catch(er => {
      reject(er);
    })
    })

  }

  // Método para limpiar timers de forma segura
  clearTimers(timers) {
    if (timers && Array.isArray(timers)) {
      timers.forEach(timer => {
        if (timer) {
          clearTimeout(timer);
          clearInterval(timer);
        }
      });
    }
  }

  // Método para limpiar EventBus listeners de forma segura
  clearEventBusListeners(eventBus, listeners) {
    if (eventBus && listeners) {
      Object.keys(listeners).forEach(eventName => {
        if (listeners[eventName]) {
          eventBus.$off(eventName, listeners[eventName]);
        }
      });
    }
  }

  // Método para limpiar sockets de forma segura
  clearSockets(sockets) {
    if (sockets) {
      Object.keys(sockets).forEach(key => {
        if (sockets[key] && typeof sockets[key].disconnect === 'function') {
          sockets[key].disconnect();
          sockets[key] = null;
        }
      });
    }
  }

  // Método para limpiar recursos de video
  clearVideoResources(videoElement) {
    if (videoElement) {
      if (videoElement.src) {
        videoElement.src = '';
      }
      if (videoElement.srcObject) {
        videoElement.srcObject = null;
      }
      videoElement.load();
    }
  }

  // Método para limpiar canvas
  clearCanvas(canvas) {
    if (canvas) {
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    }
  }

}

export default new helpers;
